/**
 * Visumo（hacobune）のタイル内キャプションを、カンプの形に整形する。
 *
 * Visumo は Instagram のキャプションを丸ごと1つの <span> に入れて出力するため、
 * CSS では一部だけを消せない。そこで描画後に必要な行だけを抜き出して差し替える。
 *
 * 抜き出す2行（Figma 237:3648 / 237:3649）:
 *   タイトル … 【】で囲まれた行（例「【新作ワンダーシェイプ】」）
 *   身長     … 「STAFF:176cm」「model：176㎝」等から数字＋cm を取り出す
 *
 * どちらも見つからない場合は元のキャプションに触れない（消し過ぎ防止）。
 * 商品詳細ページ（Staff Coordinate）のみを対象にする。
 */
(() => {
  'use strict';

  const ROOT = '.c-designer';
  const ITEM = '.hacobune-mix-list-item-description';
  const DONE = 'data-vsm-caption-formatted';

  const CLASS = {
    title: 'c-vsm-caption__title',
    height: 'c-vsm-caption__height',
  };

  /** 【】で囲まれた最初の行を返す */
  const pickTitle = (lines) => {
    const hit = lines.find((l) => /【.+】/.test(l));
    if (!hit) return '';
    const m = hit.match(/【(.+?)】/);
    return m ? `【${m[1]}】` : hit;
  };

  /** 「STAFF:176cm」「model：176㎝」等から「176cm」を取り出す */
  const pickHeight = (lines) => {
    for (const line of lines) {
      const m = line.match(/(\d{2,3})\s*(?:cm|㎝)/i);
      if (m) return `${m[1]}cm`;
    }
    return '';
  };

  const format = (el) => {
    if (el.hasAttribute(DONE)) return;

    const raw = el.textContent || '';
    const lines = raw.split('\n').map((l) => l.trim()).filter(Boolean);
    const title = pickTitle(lines);
    const height = pickHeight(lines);

    // どちらも取れないキャプションは、判断材料がないので元のまま残す
    if (!title && !height) {
      el.setAttribute(DONE, 'skip');
      return;
    }

    el.textContent = '';
    if (title) {
      const p = document.createElement('p');
      p.className = CLASS.title;
      p.textContent = title;
      el.appendChild(p);
    }
    if (height) {
      const p = document.createElement('p');
      p.className = CLASS.height;
      p.textContent = height;
      el.appendChild(p);
    }
    el.setAttribute(DONE, '1');
  };

  const run = () => {
    document.querySelectorAll(`${ROOT} ${ITEM}`).forEach(format);
  };

  const start = () => {
    run();
    // Visumo は非同期描画かつ、スライド送りなどで再描画されるため監視し続ける
    const root = document.querySelector(ROOT);
    if (!root) return;
    new MutationObserver(run).observe(root, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
